import { QuestionSkeleton } from '@/components/question-card-skeleton';
import React from 'react';

interface QuestionListSkeletonProps {
  count?: number;
}

export const QuestionListSkeleton = (
  { count = 4 }: QuestionListSkeletonProps = { count: 5 }
) => {
  return (
    <div className="p-4">
      <div className="flex flex-col gap-4">
        {Array.from({ length: count }, (_, index) => (
          <QuestionSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};
